import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import _ from 'lodash'
import { sendAsync } from '../../../app/applicationSlice'
import { RootState, RootThunkApi } from '../../../app/store'
import * as S from '../../../services/doctorAchievement'

// 业绩查询
export const getDoctorAchievementAsync = createAsyncThunk<
  void,
  S.DoctorAchievementParams,
  RootThunkApi
>('doctorAudit/getDoctorAchievementAsync ', async (params, api) => {
  return sendAsync(S.getDoctorAchievement(params), api)
})

// 导出
export const getDoctorAchievementExportAsync = createAsyncThunk<
  void,
  S.DoctorAchievementParams,
  RootThunkApi
>('doctorAudit/getDoctorAchievementExportAsync ', async (params, api) => {
  return sendAsync(S.getDoctorAchievementExport(params), api)
})

// 业绩详情导出
export const getDoctorAchievementDetailExportAsync = createAsyncThunk<
  void,
  S.DoctorAchievementDetailParams,
  RootThunkApi
>('doctorAudit/getDoctorAchievementDetailExportAsync ', async (params, api) => {
  return sendAsync(S.getDoctorAchievementDetailExport(params), api)
})

// 业绩详情
export const getDoctorAchievementDetailAsync = createAsyncThunk<
  void,
  S.DoctorAchievementDetailParams,
  RootThunkApi
>('doctorAudit/getDoctorAchievementDetailAsync ', async (params, api) => {
  return sendAsync(S.getDoctorAchievementDetail(params), api)
})